import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../context/ModalContext';
import { TableRefreshContext } from '../../context/TableRefreshContext';
import {
  ICreateRackRequest,
  ICreateRackResponse,
} from '../../models/createRack/createRack.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import useHttps from '../useHttps';

const useCreateRack = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [resetInputFields, setResetInputFields] = useState(false);
  const modalContext = useContext(ModalContext);
  const refreshTableContext = useContext(TableRefreshContext);

  const onCreateRackError = (err: AxiosError<ErrorHttpResponse>) => {
    modalContext?.displayModal(true);
    toast.error(
      err?.response?.data?.message ?? 'Something went wrong while creating rack'
    );
  };

  const onCreateRackSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<ICreateRackResponse>) => {
    setResetInputFields(true);
    modalContext?.displayModal(false);
    refreshTableContext?.setRefreshTable(!refreshTableContext?.refreshTable);
    toast.success(message);
  };

  const createRack = (data: ICreateRackRequest) => {
    const url: HttpConfig = {
      url: 'warehouse-service/api/v1/racks',
      method: 'post',
      data,
    };

    request(url, onCreateRackSuccess, setLoading, onCreateRackError);
  };

  return { createRack, loading, resetInputFields };
};

export default useCreateRack;
